import { EXTRA_ACTIVITY_TYPES } from 'common/ActivityChip/utils/extraActivities';

export const RAW_REGULAR_SHIFT_FULL_ONE_ACTIVITY = {
	activitiesV2: [
		{
			fromTimestamp: '2026-03-26T00:00:00Z',
			toTimestamp: '2026-03-26T06:00:00Z',
			activity: {
				__typename: 'CrewMemberBreakActivityItem',
				breakType: 'rest',
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-26T07:15:00Z',
			toTimestamp: '2026-03-26T20:15:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'TAT6 → NAB6',
				status: 'actual',
				activityType: 'driving',
				rideId: 'ride_tat6_nab6_260326_1',
				sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
				shiftId: 'shift_tat6_nab6_260326_1',
				fromStation: {
					code: 'TAT6',
					id: 'station_tat6',
					timezone: 'America/Chicago',
					name: 'Tatooine Dune Port',
					city: {
						id: 'city_tatooine',
						name: 'Tatooine',
					},
				},
				toStation: {
					code: 'NAB6',
					id: 'station_nab6',
					timezone: 'America/Chicago',
					name: 'Naboo Lake Hub',
					city: {
						id: 'city_naboo',
						name: 'Naboo',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_tat6_260326_1',
						shiftId: 'shift_tat6_nab6_260326_1',
						fromTimestamp: '2026-03-26T06:00:00Z',
						toTimestamp: '2026-03-26T06:30:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'TAT6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
					},
					{
						id: 'extra_cleaning_tat6_260326_1',
						shiftId: 'shift_tat6_nab6_260326_1',
						fromTimestamp: '2026-03-26T06:30:00Z',
						toTimestamp: '2026-03-26T07:15:00Z',
						activityType: 'cleaning',
						fromStation: {
							code: 'TAT6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
					},
					{
						id: 'extra_fuelling_nab6_260326_1',
						shiftId: 'shift_tat6_nab6_260326_1',
						fromTimestamp: '2026-03-26T20:15:00Z',
						toTimestamp: '2026-03-26T20:30:00Z',
						activityType: 'fuelling',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
					},
					{
						id: 'extra_signoff_nab6_260326_1',
						shiftId: 'shift_tat6_nab6_260326_1',
						fromTimestamp: '2026-03-26T20:30:00Z',
						toTimestamp: '2026-03-26T21:00:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
					},
				],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-26T21:00:00Z',
			toTimestamp: '2026-03-27T00:00:00Z',
			activity: {
				__typename: 'CrewMemberBreakActivityItem',
				breakType: 'rest',
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-27T00:00:00Z',
			toTimestamp: '2026-03-28T00:00:00Z',
			activity: {
				__typename: 'CrewMemberAbsenceActivityItem',
				note: 'Updating battle droids with laser sight',
				reason: {
					id: 'reason_droid_mentainance',
					name: 'Droid mentainance',
					code: 'DROID_MENTAINANCE',
				},
				availableForAssignments: false,
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-28T00:00:00Z',
			toTimestamp: '2026-03-28T06:00:00Z',
			activity: {
				__typename: 'CrewMemberBreakActivityItem',
				breakType: 'rest',
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-28T07:15:00Z',
			toTimestamp: '2026-03-28T20:15:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'NAB6 → HOT6',
				status: 'confirmed',
				activityType: 'driving',
				rideId: 'ride_nab6_hot6_260328_1',
				sequenceGroupId: 'seq_group_nab6_hot6_260328_1',
				shiftId: 'shift_nab6_hot6_260328_1',
				fromStation: {
					code: 'NAB6',
					id: 'station_nab6',
					timezone: 'America/Chicago',
					name: 'Naboo Lake Hub',
					city: {
						id: 'city_naboo',
						name: 'Naboo',
					},
				},
				toStation: {
					code: 'HOT6',
					id: 'station_hot6',
					timezone: 'America/Chicago',
					name: 'Hoth Ice Depot',
					city: {
						id: 'city_hoth',
						name: 'Hoth',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_nab6_260328_1',
						shiftId: 'shift_nab6_hot6_260328_1',
						fromTimestamp: '2026-03-28T06:00:00Z',
						toTimestamp: '2026-03-28T06:30:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_nab6_hot6_260328_1',
					},
					{
						id: 'extra_cleaning_nab6_260328_1',
						shiftId: 'shift_nab6_hot6_260328_1',
						fromTimestamp: '2026-03-28T06:30:00Z',
						toTimestamp: '2026-03-28T07:15:00Z',
						activityType: 'cleaning',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_nab6_hot6_260328_1',
					},
					{
						id: 'extra_fuelling_hot6_260328_1',
						shiftId: 'shift_nab6_hot6_260328_1',
						fromTimestamp: '2026-03-28T20:15:00Z',
						toTimestamp: '2026-03-28T20:30:00Z',
						activityType: 'fuelling',
						fromStation: {
							code: 'HOT6',
						},
						sequenceGroupId: 'seq_group_nab6_hot6_260328_1',
					},
					{
						id: 'extra_signoff_hot6_260328_1',
						shiftId: 'shift_nab6_hot6_260328_1',
						fromTimestamp: '2026-03-28T20:30:00Z',
						toTimestamp: '2026-03-28T21:00:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'HOT6',
						},
						sequenceGroupId: 'seq_group_nab6_hot6_260328_1',
					},
				],
			},
			isCancellable: false,
		},
	],

	shifts: [
		{
			id: 'shift_tat6_nab6_260326_1',
			fromTimestamp: '2026-03-26T06:00:00Z',
			toTimestamp: '2026-03-26T21:00:00Z',
			autoCloseTimestamp: null,
		},
		{
			id: 'shift_nab6_hot6_260328_1',
			fromTimestamp: '2026-03-28T06:00:00Z',
			toTimestamp: '2026-03-28T21:00:00Z',
			autoCloseTimestamp: null,
		},
	],
};

export const RAW_REGULAR_SHIFT_FULL_TWO_SEQUENCES = {
	activitiesV2: [
		{
			fromTimestamp: '2026-03-26T06:30:00Z',
			toTimestamp: '2026-03-26T20:30:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'TAT6 → NAB6',
				status: 'confirmed',
				activityType: 'driving',
				rideId: 'ride_tat6_nab6_260326_1',
				sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
				shiftId: 'shift_tat6_nab6_260326_1',
				fromStation: {
					code: 'TAT6',
					id: 'station_tat6',
					timezone: 'America/Chicago',
					name: 'Tatooine Dune Port',
					city: {
						id: 'city_tatooine',
						name: 'Tatooine',
					},
				},
				toStation: {
					code: 'NAB6',
					id: 'station_nab6',
					timezone: 'America/Chicago',
					name: 'Naboo Lake Hub',
					city: {
						id: 'city_naboo',
						name: 'Naboo',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_tat6_260326_1',
						shiftId: 'shift_tat6_nab6_260326_1',
						fromTimestamp: '2026-03-26T06:00:00Z',
						toTimestamp: '2026-03-26T06:30:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'TAT6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
					},
					{
						id: 'extra_signoff_nab6_260326_1',
						shiftId: 'shift_tat6_nab6_260326_1',
						fromTimestamp: '2026-03-26T20:30:00Z',
						toTimestamp: '2026-03-26T21:00:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
					},
				],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-26T21:00:00Z',
			toTimestamp: '2026-03-27T06:00:00Z',
			activity: {
				__typename: 'CrewMemberBreakActivityItem',
				breakType: 'rest',
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-27T06:30:00Z',
			toTimestamp: '2026-03-27T20:30:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'NAB6 → HOT6',
				status: 'confirmed',
				activityType: 'driving',
				rideId: 'ride_nab6_hot6_260327_1',
				sequenceGroupId: 'seq_group_nab6_hot6_260327_1',
				shiftId: 'shift_nab6_hot6_260327_1',
				fromStation: {
					code: 'NAB6',
					id: 'station_nab6',
					timezone: 'America/Chicago',
					name: 'Naboo Lake Hub',
					city: {
						id: 'city_naboo',
						name: 'Naboo',
					},
				},
				toStation: {
					code: 'HOT6',
					id: 'station_hot6',
					timezone: 'America/Chicago',
					name: 'Hoth Ice Depot',
					city: {
						id: 'city_hoth',
						name: 'Hoth',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_nab6_260327_1',
						shiftId: 'shift_nab6_hot6_260327_1',
						fromTimestamp: '2026-03-27T06:00:00Z',
						toTimestamp: '2026-03-27T06:30:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_nab6_hot6_260327_1',
					},
					{
						id: 'extra_signoff_hot6_260327_1',
						shiftId: 'shift_nab6_hot6_260327_1',
						fromTimestamp: '2026-03-27T20:30:00Z',
						toTimestamp: '2026-03-27T21:00:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'HOT6',
						},
						sequenceGroupId: 'seq_group_nab6_hot6_260327_1',
					},
				],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-27T21:00:00Z',
			toTimestamp: '2026-03-28T06:00:00Z',
			activity: {
				__typename: 'CrewMemberBreakActivityItem',
				breakType: 'rest',
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-28T06:30:00Z',
			toTimestamp: '2026-03-28T20:30:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'HOT6 → COR6',
				status: 'confirmed',
				activityType: 'driving',
				rideId: 'ride_hot6_cor6_260328_1',
				sequenceGroupId: 'seq_group_hot6_cor6_260328_1',
				shiftId: 'shift_hot6_cor6_260328_1',
				fromStation: {
					code: 'HOT6',
					id: 'station_hot6',
					timezone: 'America/Chicago',
					name: 'Hoth Ice Depot',
					city: {
						id: 'city_hoth',
						name: 'Hoth',
					},
				},
				toStation: {
					code: 'COR6',
					id: 'station_cor6',
					timezone: 'America/Chicago',
					name: 'Coruscant Sky Terminal',
					city: {
						id: 'city_coruscant',
						name: 'Coruscant',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_hot6_260328_1',
						shiftId: 'shift_hot6_cor6_260328_1',
						fromTimestamp: '2026-03-28T06:00:00Z',
						toTimestamp: '2026-03-28T06:30:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'HOT6',
						},
						sequenceGroupId: 'seq_group_hot6_cor6_260328_1',
					},
					{
						id: 'extra_signoff_cor6_260328_1',
						shiftId: 'shift_hot6_cor6_260328_1',
						fromTimestamp: '2026-03-28T20:30:00Z',
						toTimestamp: '2026-03-28T21:00:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'COR6',
						},
						sequenceGroupId: 'seq_group_hot6_cor6_260328_1',
					},
				],
			},
			isCancellable: false,
		},
	],

	shifts: [
		{
			id: 'shift_tat6_nab6_260326_1',
			fromTimestamp: '2026-03-26T06:00:00Z',
			toTimestamp: '2026-03-26T21:00:00Z',
			autoCloseTimestamp: null,
		},
		{
			id: 'shift_nab6_hot6_260327_1',
			fromTimestamp: '2026-03-27T06:00:00Z',
			toTimestamp: '2026-03-27T21:00:00Z',
			autoCloseTimestamp: null,
		},
		{
			id: 'shift_hot6_cor6_260328_1',
			fromTimestamp: '2026-03-28T06:00:00Z',
			toTimestamp: '2026-03-28T21:00:00Z',
			autoCloseTimestamp: null,
		},
	],
};

export const RAW_REGULAR_THREE_DAYS_FULL_COVERAGE = {
	activitiesV2: [
		{
			fromTimestamp: '2026-03-26T07:15:00Z',
			toTimestamp: '2026-03-26T11:15:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'TAT6 → NAB6',
				status: 'actual',
				activityType: 'driving',
				rideId: 'ride_tat6_nab6_260326_1',
				sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
				shiftId: 'shift_day1_260326_1',
				fromStation: {
					code: 'TAT6',
					id: 'station_tat6',
					timezone: 'America/Chicago',
					name: 'Tatooine Dune Port',
					city: {
						id: 'city_tatooine',
						name: 'Tatooine',
					},
				},
				toStation: {
					code: 'NAB6',
					id: 'station_nab6',
					timezone: 'America/Chicago',
					name: 'Naboo Lake Hub',
					city: {
						id: 'city_naboo',
						name: 'Naboo',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_tat6_260326_1',
						shiftId: 'shift_day1_260326_1',
						fromTimestamp: '2026-03-26T06:00:00Z',
						toTimestamp: '2026-03-26T06:30:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'TAT6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
					},
					{
						id: 'extra_cleaning_tat6_260326_1',
						shiftId: 'shift_day1_260326_1',
						fromTimestamp: '2026-03-26T06:30:00Z',
						toTimestamp: '2026-03-26T07:15:00Z',
						activityType: 'cleaning',
						fromStation: {
							code: 'TAT6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
					},
					{
						id: 'extra_fuelling_nab6_260326_1',
						shiftId: 'shift_day1_260326_1',
						fromTimestamp: '2026-03-26T11:15:00Z',
						toTimestamp: '2026-03-26T11:30:00Z',
						activityType: 'fuelling',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
					},
					{
						id: 'extra_signoff_nab6_260326_1',
						shiftId: 'shift_day1_260326_1',
						fromTimestamp: '2026-03-26T11:30:00Z',
						toTimestamp: '2026-03-26T12:00:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_1',
					},
				],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-26T12:00:00Z',
			toTimestamp: '2026-03-26T16:30:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'NAB6 → COR6',
				status: 'confirmed',
				activityType: 'traveling',
				rideId: 'ride_nab6_cor6_260326_1',
				sequenceGroupId: 'seq_group_nab6_cor6_260326_1',
				shiftId: 'shift_day1_260326_1',
				fromStation: {
					code: 'NAB6',
					id: 'station_nab6',
					timezone: 'America/Chicago',
					name: 'Naboo Lake Hub',
					city: {
						id: 'city_naboo',
						name: 'Naboo',
					},
				},
				toStation: {
					code: 'COR6',
					id: 'station_cor6',
					timezone: 'America/Chicago',
					name: 'Coruscant Sky Terminal',
					city: {
						id: 'city_coruscant',
						name: 'Coruscant',
					},
				},
				note: '',
				extraActivities: [],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-26T17:00:00Z',
			toTimestamp: '2026-03-26T20:00:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'COR6 → JAK6',
				status: 'pending',
				activityType: 'driving',
				rideId: 'ride_cor6_jak6_260326_1',
				sequenceGroupId: 'seq_group_cor6_jak6_260326_1',
				shiftId: 'shift_day1_260326_1',
				fromStation: {
					code: 'COR6',
					id: 'station_cor6',
					timezone: 'America/Chicago',
					name: 'Coruscant Sky Terminal',
					city: {
						id: 'city_coruscant',
						name: 'Coruscant',
					},
				},
				toStation: {
					code: 'JAK6',
					id: 'station_jak6',
					timezone: 'America/Chicago',
					name: 'Jakku Scrap Gate',
					city: {
						id: 'city_jakku',
						name: 'Jakku',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_cor6_260326_1',
						shiftId: 'shift_day1_260326_1',
						fromTimestamp: '2026-03-26T16:30:00Z',
						toTimestamp: '2026-03-26T17:00:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'COR6',
						},
						sequenceGroupId: 'seq_group_cor6_jak6_260326_1',
					},
					{
						id: 'extra_garaging_jak6_260326_1',
						shiftId: 'shift_day1_260326_1',
						fromTimestamp: '2026-03-26T20:00:00Z',
						toTimestamp: '2026-03-26T20:30:00Z',
						activityType: 'garaging',
						fromStation: {
							code: 'JAK6',
						},
						sequenceGroupId: 'seq_group_cor6_jak6_260326_1',
					},
					{
						id: 'extra_signoff_jak6_260326_1',
						shiftId: 'shift_day1_260326_1',
						fromTimestamp: '2026-03-26T20:30:00Z',
						toTimestamp: '2026-03-26T21:00:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'JAK6',
						},
						sequenceGroupId: 'seq_group_cor6_jak6_260326_1',
					},
				],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-26T21:00:00Z',
			toTimestamp: '2026-03-27T06:00:00Z',
			activity: {
				__typename: 'CrewMemberBreakActivityItem',
				breakType: 'rest',
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-27T06:00:00Z',
			toTimestamp: '2026-03-27T11:00:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'JAK6 → END6',
				status: 'created',
				activityType: 'deadhead',
				rideId: 'ride_jak6_end6_260327_1',
				sequenceGroupId: 'seq_group_jak6_end6_260327_1',
				shiftId: 'shift_day2_260327_1',
				fromStation: {
					code: 'JAK6',
					id: 'station_jak6',
					timezone: 'America/Chicago',
					name: 'Jakku Scrap Gate',
					city: {
						id: 'city_jakku',
						name: 'Jakku',
					},
				},
				toStation: {
					code: 'END6',
					id: 'station_end6',
					timezone: 'America/Chicago',
					name: 'Endor Forest Point',
					city: {
						id: 'city_endor',
						name: 'Endor',
					},
				},
				note: '',
				extraActivities: [],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-27T11:00:00Z',
			toTimestamp: '2026-03-27T15:00:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'END6 → MUS6',
				status: 'confirmed',
				activityType: 'protection',
				rideId: 'ride_end6_mus6_260327_1',
				sequenceGroupId: 'seq_group_end6_mus6_260327_1',
				shiftId: 'shift_day2_260327_1',
				fromStation: {
					code: 'END6',
					id: 'station_end6',
					timezone: 'America/Chicago',
					name: 'Endor Forest Point',
					city: {
						id: 'city_endor',
						name: 'Endor',
					},
				},
				toStation: {
					code: 'MUS6',
					id: 'station_mus6',
					timezone: 'America/Chicago',
					name: 'Mustafar Ash Dock',
					city: {
						id: 'city_mustafar',
						name: 'Mustafar',
					},
				},
				note: '',
				extraActivities: [],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-27T15:00:00Z',
			toTimestamp: '2026-03-27T21:00:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'MUS6 → HOT6',
				status: 'actual',
				activityType: 'deadhead',
				rideId: 'ride_mus6_hot6_260327_1',
				sequenceGroupId: 'seq_group_mus6_hot6_260327_1',
				shiftId: 'shift_day2_260327_1',
				fromStation: {
					code: 'MUS6',
					id: 'station_mus6',
					timezone: 'America/Chicago',
					name: 'Mustafar Ash Dock',
					city: {
						id: 'city_mustafar',
						name: 'Mustafar',
					},
				},
				toStation: {
					code: 'HOT6',
					id: 'station_hot6',
					timezone: 'America/Chicago',
					name: 'Hoth Ice Depot',
					city: {
						id: 'city_hoth',
						name: 'Hoth',
					},
				},
				note: '',
				extraActivities: [],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-27T21:00:00Z',
			toTimestamp: '2026-03-28T06:00:00Z',
			activity: {
				__typename: 'CrewMemberBreakActivityItem',
				breakType: 'rest',
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-28T06:00:00Z',
			toTimestamp: '2026-03-28T10:00:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'HOT6 → ALD6',
				status: 'pending',
				activityType: 'traveling',
				rideId: 'ride_hot6_ald6_260328_1',
				sequenceGroupId: 'seq_group_hot6_ald6_260328_1',
				shiftId: 'shift_day3_260328_1',
				fromStation: {
					code: 'HOT6',
					id: 'station_hot6',
					timezone: 'America/Chicago',
					name: 'Hoth Ice Depot',
					city: {
						id: 'city_hoth',
						name: 'Hoth',
					},
				},
				toStation: {
					code: 'ALD6',
					id: 'station_ald6',
					timezone: 'America/Chicago',
					name: 'Alderaan Crown Stop',
					city: {
						id: 'city_alderaan',
						name: 'Alderaan',
					},
				},
				note: '',
				extraActivities: [],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-28T10:30:00Z',
			toTimestamp: '2026-03-28T16:30:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'ALD6 → NAB6',
				status: 'confirmed',
				activityType: 'driving',
				rideId: 'ride_ald6_nab6_260328_1',
				sequenceGroupId: 'seq_group_ald6_nab6_260328_1',
				shiftId: 'shift_day3_260328_1',
				fromStation: {
					code: 'ALD6',
					id: 'station_ald6',
					timezone: 'America/Chicago',
					name: 'Alderaan Crown Stop',
					city: {
						id: 'city_alderaan',
						name: 'Alderaan',
					},
				},
				toStation: {
					code: 'NAB6',
					id: 'station_nab6',
					timezone: 'America/Chicago',
					name: 'Naboo Lake Hub',
					city: {
						id: 'city_naboo',
						name: 'Naboo',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_ald6_260328_1',
						shiftId: 'shift_day3_260328_1',
						fromTimestamp: '2026-03-28T10:00:00Z',
						toTimestamp: '2026-03-28T10:30:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'ALD6',
						},
						sequenceGroupId: 'seq_group_ald6_nab6_260328_1',
					},
					{
						id: 'extra_cleaning_nab6_260328_1',
						shiftId: 'shift_day3_260328_1',
						fromTimestamp: '2026-03-28T16:30:00Z',
						toTimestamp: '2026-03-28T17:15:00Z',
						activityType: 'cleaning',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_ald6_nab6_260328_1',
					},
					{
						id: 'extra_signoff_nab6_260328_2',
						shiftId: 'shift_day3_260328_1',
						fromTimestamp: '2026-03-28T17:15:00Z',
						toTimestamp: '2026-03-28T17:45:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_ald6_nab6_260328_1',
					},
				],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-28T17:45:00Z',
			toTimestamp: '2026-03-28T21:00:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'NAB6 → TAT6',
				status: 'created',
				activityType: 'protection',
				rideId: 'ride_nab6_tat6_260328_1',
				sequenceGroupId: 'seq_group_nab6_tat6_260328_1',
				shiftId: 'shift_day3_260328_1',
				fromStation: {
					code: 'NAB6',
					id: 'station_nab6',
					timezone: 'America/Chicago',
					name: 'Naboo Lake Hub',
					city: {
						id: 'city_naboo',
						name: 'Naboo',
					},
				},
				toStation: {
					code: 'TAT6',
					id: 'station_tat6',
					timezone: 'America/Chicago',
					name: 'Tatooine Dune Port',
					city: {
						id: 'city_tatooine',
						name: 'Tatooine',
					},
				},
				note: '',
				extraActivities: [],
			},
			isCancellable: false,
		},
	],

	shifts: [
		{
			id: 'shift_day1_260326_1',
			fromTimestamp: '2026-03-26T06:00:00Z',
			toTimestamp: '2026-03-26T21:00:00Z',
			autoCloseTimestamp: null,
		},
		{
			id: 'shift_day2_260327_1',
			fromTimestamp: '2026-03-27T06:00:00Z',
			toTimestamp: '2026-03-27T21:00:00Z',
			autoCloseTimestamp: null,
		},
		{
			id: 'shift_day3_260328_1',
			fromTimestamp: '2026-03-28T06:00:00Z',
			toTimestamp: '2026-03-28T21:00:00Z',
			autoCloseTimestamp: null,
		},
	],
};

export const RAW_THREE_DAYS_AUTOCLOSE_VARIANTS = {
	activitiesV2: [
		{
			fromTimestamp: '2026-03-26T00:31:00Z',
			toTimestamp: '2026-03-26T11:31:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'TAT6 → NAB6',
				status: 'confirmed',
				activityType: 'driving',
				rideId: 'ride_tat6_nab6_260326_auto_1',
				sequenceGroupId: 'seq_group_tat6_nab6_260326_auto_1',
				shiftId: 'shift_tat6_nab6_260326_auto_1',
				fromStation: {
					code: 'TAT6',
					id: 'station_tat6',
					timezone: 'America/Chicago',
					name: 'Tatooine Dune Port',
					city: {
						id: 'city_tatooine',
						name: 'Tatooine',
					},
				},
				toStation: {
					code: 'NAB6',
					id: 'station_nab6',
					timezone: 'America/Chicago',
					name: 'Naboo Lake Hub',
					city: {
						id: 'city_naboo',
						name: 'Naboo',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_tat6_260326_auto_1',
						shiftId: 'shift_tat6_nab6_260326_auto_1',
						fromTimestamp: '2026-03-26T00:01:00Z',
						toTimestamp: '2026-03-26T00:31:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'TAT6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_auto_1',
					},
					{
						id: 'extra_signoff_nab6_260326_auto_1',
						shiftId: 'shift_tat6_nab6_260326_auto_1',
						fromTimestamp: '2026-03-26T11:31:00Z',
						toTimestamp: '2026-03-26T12:01:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_tat6_nab6_260326_auto_1',
					},
				],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-26T15:01:00Z',
			toTimestamp: '2026-03-27T00:01:00Z',
			activity: {
				__typename: 'CrewMemberBreakActivityItem',
				breakType: 'rest',
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-27T00:31:00Z',
			toTimestamp: '2026-03-27T01:01:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'NAB6 → HOT6',
				status: 'confirmed',
				activityType: 'driving',
				rideId: 'ride_nab6_hot6_260327_auto_1',
				sequenceGroupId: 'seq_group_nab6_hot6_260327_auto_1',
				shiftId: 'shift_nab6_hot6_260327_auto_1',
				fromStation: {
					code: 'NAB6',
					id: 'station_nab6',
					timezone: 'America/Chicago',
					name: 'Naboo Lake Hub',
					city: {
						id: 'city_naboo',
						name: 'Naboo',
					},
				},
				toStation: {
					code: 'HOT6',
					id: 'station_hot6',
					timezone: 'America/Chicago',
					name: 'Hoth Ice Depot',
					city: {
						id: 'city_hoth',
						name: 'Hoth',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_nab6_260327_auto_1',
						shiftId: 'shift_nab6_hot6_260327_auto_1',
						fromTimestamp: '2026-03-27T00:01:00Z',
						toTimestamp: '2026-03-27T00:31:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'NAB6',
						},
						sequenceGroupId: 'seq_group_nab6_hot6_260327_auto_1',
					},
					{
						id: 'extra_signoff_hot6_260327_auto_1',
						shiftId: 'shift_nab6_hot6_260327_auto_1',
						fromTimestamp: '2026-03-27T01:01:00Z',
						toTimestamp: '2026-03-27T01:31:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'HOT6',
						},
						sequenceGroupId: 'seq_group_nab6_hot6_260327_auto_1',
					},
				],
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-27T15:01:00Z',
			toTimestamp: '2026-03-28T00:01:00Z',
			activity: {
				__typename: 'CrewMemberBreakActivityItem',
				breakType: 'rest',
			},
			isCancellable: false,
		},
		{
			fromTimestamp: '2026-03-28T00:31:00Z',
			toTimestamp: '2026-03-28T07:01:00Z',
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: 'HOT6 → COR6',
				status: 'confirmed',
				activityType: 'driving',
				rideId: 'ride_hot6_cor6_260328_auto_1',
				sequenceGroupId: 'seq_group_hot6_cor6_260328_auto_1',
				shiftId: 'shift_hot6_cor6_260328_auto_1',
				fromStation: {
					code: 'HOT6',
					id: 'station_hot6',
					timezone: 'America/Chicago',
					name: 'Hoth Ice Depot',
					city: {
						id: 'city_hoth',
						name: 'Hoth',
					},
				},
				toStation: {
					code: 'COR6',
					id: 'station_cor6',
					timezone: 'America/Chicago',
					name: 'Coruscant Sky Terminal',
					city: {
						id: 'city_coruscant',
						name: 'Coruscant',
					},
				},
				note: '',
				extraActivities: [
					{
						id: 'extra_signon_hot6_260328_auto_1',
						shiftId: 'shift_hot6_cor6_260328_auto_1',
						fromTimestamp: '2026-03-28T00:01:00Z',
						toTimestamp: '2026-03-28T00:31:00Z',
						activityType: 'signOn',
						fromStation: {
							code: 'HOT6',
						},
						sequenceGroupId: 'seq_group_hot6_cor6_260328_auto_1',
					},
					{
						id: 'extra_signoff_cor6_260328_auto_1',
						shiftId: 'shift_hot6_cor6_260328_auto_1',
						fromTimestamp: '2026-03-28T07:01:00Z',
						toTimestamp: '2026-03-28T07:31:00Z',
						activityType: 'signOff',
						fromStation: {
							code: 'COR6',
						},
						sequenceGroupId: 'seq_group_hot6_cor6_260328_auto_1',
					},
				],
			},
			isCancellable: false,
		},
	],

	shifts: [
		{
			id: 'shift_tat6_nab6_260326_auto_1',
			fromTimestamp: '2026-03-26T00:01:00Z',
			toTimestamp: '2026-03-26T15:01:00Z',
			autoCloseTimestamp: '2026-03-26T14:16:00Z',
		},
		{
			id: 'shift_nab6_hot6_260327_auto_1',
			fromTimestamp: '2026-03-27T00:01:00Z',
			toTimestamp: '2026-03-27T15:01:00Z',
			autoCloseTimestamp: '2026-03-27T09:01:00Z',
		},
		{
			id: 'shift_hot6_cor6_260328_auto_1',
			fromTimestamp: '2026-03-28T00:01:00Z',
			toTimestamp: '2026-03-28T15:01:00Z',
			autoCloseTimestamp: '2026-03-28T13:31:00Z',
		},
	],
};

const SHORT_SHIFT_STATIONS = {
	TAT6: {
		code: 'TAT6',
		id: 'station_tat6',
		timezone: 'America/Chicago',
		name: 'Tatooine Dune Port',
		city: {
			id: 'city_tatooine',
			name: 'Tatooine',
		},
	},
	NAB6: {
		code: 'NAB6',
		id: 'station_nab6',
		timezone: 'America/Chicago',
		name: 'Naboo Lake Hub',
		city: {
			id: 'city_naboo',
			name: 'Naboo',
		},
	},
	COR6: {
		code: 'COR6',
		id: 'station_cor6',
		timezone: 'America/Chicago',
		name: 'Coruscant Sky Terminal',
		city: {
			id: 'city_coruscant',
			name: 'Coruscant',
		},
	},
	JAK6: {
		code: 'JAK6',
		id: 'station_jak6',
		timezone: 'America/Chicago',
		name: 'Jakku Scrap Gate',
		city: {
			id: 'city_jakku',
			name: 'Jakku',
		},
	},
};

const SHORT_SHIFT_ROUTES = [
	{
		from: SHORT_SHIFT_STATIONS.TAT6,
		to: SHORT_SHIFT_STATIONS.NAB6,
	},
	{
		from: SHORT_SHIFT_STATIONS.NAB6,
		to: SHORT_SHIFT_STATIONS.COR6,
	},
	{
		from: SHORT_SHIFT_STATIONS.COR6,
		to: SHORT_SHIFT_STATIONS.JAK6,
	},
];

const SHORT_SHIFT_EXTRA_DURATIONS = {
	[EXTRA_ACTIVITY_TYPES.signOn]: 30,
	[EXTRA_ACTIVITY_TYPES.signOff]: 30,
	[EXTRA_ACTIVITY_TYPES.fuelling]: 15,
	[EXTRA_ACTIVITY_TYPES.cleaning]: 45,
	[EXTRA_ACTIVITY_TYPES.garaging]: 30,
	[EXTRA_ACTIVITY_TYPES.lapseTime]: 30,
};

const SHORT_SHIFT_EXTRA_COMBINATIONS = [
	{
		pre: [EXTRA_ACTIVITY_TYPES.signOn],
		post: [EXTRA_ACTIVITY_TYPES.signOff],
	},
	{
		pre: [EXTRA_ACTIVITY_TYPES.garaging],
		post: [EXTRA_ACTIVITY_TYPES.lapseTime, EXTRA_ACTIVITY_TYPES.cleaning],
	},
	{
		pre: [EXTRA_ACTIVITY_TYPES.signOn, EXTRA_ACTIVITY_TYPES.fuelling],
		post: [EXTRA_ACTIVITY_TYPES.cleaning, EXTRA_ACTIVITY_TYPES.signOff],
	},
];

const SHORT_SHIFT_REST_MINUTES = 180;
const RAW_SHORT_SHIFT_ANCHOR = Date.UTC(2026, 2, 26, 0, 0);

const toRawIso = (minuteOffset) =>
	new Date(RAW_SHORT_SHIFT_ANCHOR + minuteOffset * 60 * 1000).toISOString().replace('.000Z', 'Z');

const normalizeExtraTypeForId = (type) =>
	type
		.replace(/([A-Z])/g, '_$1')
		.toLowerCase()
		.replace(/^_/, '');

const sumExtraMinutes = (types) =>
	types.reduce((total, type) => total + SHORT_SHIFT_EXTRA_DURATIONS[type], 0);

const createShortShiftExtra = ({
	type,
	phase,
	key,
	shiftIndex,
	position,
	shiftId,
	sequenceGroupId,
	station,
	fromMinute,
}) => {
	const durationMinutes = SHORT_SHIFT_EXTRA_DURATIONS[type];
	const normalizedType = normalizeExtraTypeForId(type);

	return {
		id: `extra_${normalizedType}_${phase}_${key}_${shiftIndex + 1}_${position + 1}`,
		version: 1,
		shiftId,
		fromTimestamp: toRawIso(fromMinute),
		toTimestamp: toRawIso(fromMinute + durationMinutes),
		activityType: type,
		durationMinutes,
		fromStation: {
			id: station.id,
			code: station.code,
			timezone: station.timezone,
			name: station.name,
		},
		toStation: {
			id: station.id,
			code: station.code,
			timezone: station.timezone,
			name: station.name,
		},
		sequenceGroupId,
	};
};

const createShortShiftActivity = ({ key, shiftMinutes, shiftStartMinute, shiftIndex }) => {
	const route = SHORT_SHIFT_ROUTES[shiftIndex];
	const combination = SHORT_SHIFT_EXTRA_COMBINATIONS[shiftIndex];
	const shiftId = `shift_${key}_${shiftIndex + 1}`;
	const sequenceGroupId = `seq_group_${key}_${shiftIndex + 1}`;
	const rideId = `ride_${route.from.code.toLowerCase()}_${route.to.code.toLowerCase()}_${key}_${
		shiftIndex + 1
	}`;
	const preMinutes = sumExtraMinutes(combination.pre);
	const postMinutes = sumExtraMinutes(combination.post);
	const assignmentStartMinute = shiftStartMinute + preMinutes;
	const assignmentEndMinute = shiftStartMinute + shiftMinutes - postMinutes;
	let cursorMinute = shiftStartMinute;

	const preExtras = combination.pre.map((type, position) => {
		const extra = createShortShiftExtra({
			type,
			phase: 'pre',
			key,
			shiftIndex,
			position,
			shiftId,
			sequenceGroupId,
			station: route.from,
			fromMinute: cursorMinute,
		});

		cursorMinute += SHORT_SHIFT_EXTRA_DURATIONS[type];
		return extra;
	});

	cursorMinute = assignmentEndMinute;

	const postExtras = combination.post.map((type, position) => {
		const extra = createShortShiftExtra({
			type,
			phase: 'post',
			key,
			shiftIndex,
			position,
			shiftId,
			sequenceGroupId,
			station: route.to,
			fromMinute: cursorMinute,
		});

		cursorMinute += SHORT_SHIFT_EXTRA_DURATIONS[type];
		return extra;
	});

	return {
		shift: {
			id: shiftId,
			fromTimestamp: toRawIso(shiftStartMinute),
			toTimestamp: toRawIso(shiftStartMinute + shiftMinutes),
			autoCloseTimestamp: null,
		},
		activity: {
			fromTimestamp: toRawIso(assignmentStartMinute),
			toTimestamp: toRawIso(assignmentEndMinute),
			activity: {
				__typename: 'CrewMemberWorkAssignmentActivityItem',
				title: `${route.from.code} → ${route.to.code}`,
				status: ['actual', 'confirmed', 'pending'][shiftIndex],
				activityType: 'driving',
				rideId,
				sequenceGroupId,
				shiftId,
				fromStation: route.from,
				toStation: route.to,
				firstWorkAssignmentId: `work_assignment_${key}_${shiftIndex + 1}`,
				firstWorkAssignmentVersion: 1,
				note: '',
				extraActivities: [...preExtras, ...postExtras],
			},
			isCancellable: false,
		},
	};
};

const createShortShiftRaw = ({ key, shiftMinutes, firstShiftStartMinute }) => {
	const shifts = [];
	const activitiesV2 = [];

	SHORT_SHIFT_EXTRA_COMBINATIONS.forEach((_, shiftIndex) => {
		const shiftStartMinute =
			firstShiftStartMinute + shiftIndex * (shiftMinutes + SHORT_SHIFT_REST_MINUTES);
		const previousShift = shifts[shifts.length - 1];

		if (previousShift) {
			activitiesV2.push({
				fromTimestamp: previousShift.toTimestamp,
				toTimestamp: toRawIso(shiftStartMinute),
				activity: {
					__typename: 'CrewMemberBreakActivityItem',
					breakType: 'rest',
				},
				isCancellable: false,
			});
		}

		const { shift, activity } = createShortShiftActivity({
			key,
			shiftMinutes,
			shiftStartMinute,
			shiftIndex,
		});

		shifts.push(shift);
		activitiesV2.push(activity);
	});

	return {
		activitiesV2,
		shifts,
	};
};

export const RAW_SHORT_SHIFT_3H = createShortShiftRaw({
	key: 'short_3h',
	shiftMinutes: 180,
	firstShiftStartMinute: 8 * 60,
});

export const RAW_SHORT_SHIFT_5H = createShortShiftRaw({
	key: 'short_5h',
	shiftMinutes: 300,
	firstShiftStartMinute: 0,
});

export const RAW_SHORT_SHIFT_7H = createShortShiftRaw({
	key: 'short_7h',
	shiftMinutes: 420,
	firstShiftStartMinute: 0,
});

export const RAW_SHORT_SHIFT_9H = createShortShiftRaw({
	key: 'short_9h',
	shiftMinutes: 540,
	firstShiftStartMinute: 0,
});
